import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { authorizationRoutes } from "../../Routes/paths";
import { FORCED_AUTHENTICATION } from "../../util/constants";
import useSignIn from "./useSignIn";
import useOAuthRedirect from "./useOAuthRedirect";
import useLogOutOnIdle from "./useLogOutOnIdle";

function useCompleteAuthFlowHandler() {
  const location = useLocation();
  const { handleSignIn } = useSignIn();
  const onAuthPage = Object.values(authorizationRoutes).includes(
    location.pathname
  );

  useOAuthRedirect()
  useLogOutOnIdle()

  useEffect(() => {
    if (!onAuthPage) {
      handleSignIn({ doNotRedirect: !FORCED_AUTHENTICATION });
    }
  }, [handleSignIn, onAuthPage]);
}
export default useCompleteAuthFlowHandler;
